// extracted by mini-css-extract-plugin
export default {"list":"love-language_list__tbzPZ","arrow_icon":"love-language_arrow_icon__0g-jR"};